import { del, get, post, put } from '@/shared/api/api-client';
import { injectable } from 'inversify';
import { BuyerInstance, SuccessResponse } from '../ts';
import { IRustmixBuyer } from '@/modules/mixing/ts/rustmix-buyer.types';
import md5 from 'md5';

@injectable()
export class BuyersService {
  getAllBuyers({ sort_by = 'id', order_by = 'asc', search }: { sort_by?: string, order_by?: 'asc' | 'desc', search?: string }): Promise<BuyerInstance[]> {
    return get(`${PUBLIC_API_URL}/buyer`, search && search !== '' ? { limit: 100, sort_by, sort_order: order_by, search } : { limit: 100, sort_by, sort_order: order_by }, document.cookie);
  }

  getBuyerById(id: number): Promise<BuyerInstance> {
    return get(`${PUBLIC_API_URL}/buyer/${id}`, {}, document.cookie);
  }

  getBuyerByMd5(md5: string): Promise<BuyerInstance> {
    return get(`${PUBLIC_API_URL}/buyer/0`, { param: md5 }, document.cookie);
  }

  createNewBuyer(buyerDto: any): Promise<SuccessResponse> {
    return post(`${PUBLIC_API_URL}/buyer`, { ...buyerDto }, document.cookie);
  }

  updateBuyerById(
    id: number,
    updateBuyerDto: any,
    md5?: string,
  ): Promise<BuyerInstance> {
    if (md5) {
      return put(`${PUBLIC_API_URL}/buyer/0?param=${md5}`, { ...updateBuyerDto });
    }
    return put(`${PUBLIC_API_URL}/buyer/${id}`, { ...updateBuyerDto });
  }

  deleteBuyerById(id: number): Promise<SuccessResponse> {
    return del(`${PUBLIC_API_URL}/buyer/${id}`);
  }

  searchBuyersAddress(query: string): Promise<any> {
    return get(`${PUBLIC_API_URL}/address_search`, { query });
  }

  searchBuyerInGlobalDatabase(query: string): Promise<any> {
    return get(`${PUBLIC_API_URL}/company_search`, { query });
  }

  getRustmixBuyers(): Promise<IRustmixBuyer[]> {
    return get(`${PUBLIC_RUSTMIX_URL}/companies`, {});
  }

  getUserBuyers() {
    return get(`${PUBLIC_API_URL}/buyer`, { limit: 500 });
  }

  getRustmixPrices(companyId: number): Promise<any> {
    return get(`${PUBLIC_RUSTMIX_URL}/prices`, { company_id: companyId });
  }

  getUserBuyersOffers({ company_name, id, type }: IRustmixBuyer) {
    return get(
      `${PUBLIC_API_URL}/buyeroffer/${type === 'internal' ? id : '0'}`,
      type === 'external' ? { param: md5(company_name) } : {},
    );
  }

  getBuyerReceivingPoints(id: number) {
    return get(`${PUBLIC_API_URL}/buyer_grain_receiving_points/${id}`);
  }

  createBuyerReceivingPoints(data: {
    buyer_id: number;
    region: string;
    city: string;
    street: string;
    house: string;
  }) {
    return post(`${PUBLIC_API_URL}/grain_receiving_points`, data);
  }

  deleteReceivingPoint(id: number) {
    return del(`${PUBLIC_API_URL}/grain_receiving_points/${id}`);
  }

  editGrainReceivingPoint (data: {
    id: number;
    region?: string;
    city?: string;
    street?: string;
    house?: string;
  }) {
    return put(`${PUBLIC_API_URL}/grain_receiving_points/${data.id}`, { ...data })
  }

  getPriceDynamics(id: number) {
    return get(`${PUBLIC_API_URL}/price_dynamics/${id}`)
  }

  getOffersMatrix({payload} : { payload: { id: number, is_internal: boolean }[] }) {
    return put(`${PUBLIC_API_URL}/calculator`, { ...payload });
  }

  switchAllBuyers({ enabled }: { enabled: boolean }) {
    return put(`${PUBLIC_API_URL}/enable_all_buyers`, { enabled });
  }
}
